import React, { FC } from 'react';
import { Category } from 'shared/types/product/Category';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Tile } from 'components/commercetools-ui/organisms/header/types';
import useClassNames from 'helpers/hooks/useClassNames';
import HeaderDropdownTile from './header-menu-tile';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import Button from 'components/commercetools-ui/atoms/button';
import { PlusIcon } from '@heroicons/react/24/solid';

export interface Props {
  show: boolean | undefined;
  links: any[];
  tileContent?: Tile;
  onClick?: () => void;
}

const MenuDropdown: FC<Props> = ({ show, links, tileContent, onClick }) => {
  const wrapperClassNames = useClassNames([
    'transition absolute overflow-y-auto flex justify-between bottom-0 left-0 duration-300 ease-in-out min-h-[20rem] 2xl:min-h-[30rem] w-[100%] translate-y-full',
    show ? 'opacity-1 z-20 delay-300' : 'opacity-0 z-[-999] pointer-events-none',
    'bg-[#F3EDE9] py-40 px-48 xl:p-60 2xl:p-80',
  ]);

  const linksClassNames = useClassNames(['grid gap-x-64 gap-y-28', tileContent ? 'pr-116' : '', 'grid-cols-12']);

  return (
    <div className={wrapperClassNames}>
      <div className={linksClassNames}>

        {links?.map((link) => (
          
          <div
            key={link?.label}
            className={`${
              link?.title === 'Planning tools'
                ? 'col-span-6'
                : (link?.title === 'About Us')
                ? 'col-span-4'
                : (link?.title === 'Support')
                ? 'col-span-4'
                : (link?.title === 'Our Other Brands')
                ? 'col-span-4'                
                : link?.mega_menu.length === 4
                ? 'col-span-4'
                : (link?.mega_menu.length === 2 && link?.title === 'Kitchen & Laundry')
                ? 'col-span-10 xl:col-span-8'
                : (link?.mega_menu.length === 3 && link?.title === 'Product Range')
                ? 'col-span-6'
                : link?.mega_menu.length === 2                
                ? 'col-span-4'
                : (link?.mega_menu.length === 1)                
                ? 'col-span-2'
                : link?.mega_menu.length === 6 || link?.title === ''
                ? 'col-span-6'
                : 'col-span-10 xl:col-span-8'
             }`}
          >

            <div className="w-min pb-16 2xl:pb-26">
                <Typography className="whitespace-nowrap font-semibold text-[#2B2C39] md:text-16 2xl:text-20">{link?.title}</Typography>
            </div>

            {/* ======================================================================================================================================== */}
            <div
              className={`grid
              ${
                link?.title === 'Planning tools'
                  ? 'grid-cols-1'
                  : (link?.title === 'About Us')
                  ? 'grid-cols-2 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30 mr-[25px]'
                  : (link?.title === 'Support')
                  ? 'grid-cols-2 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30 mr-[25px]'
                  : (link?.title === 'Our Other Brands')
                  ? 'grid-cols-2 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30'
                  : (link?.mega_menu.length === 2 && link?.title === 'Kitchen & Laundry')
                  ? 'grid-cols-3 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30'
                  : (link?.mega_menu.length === 3 && link?.title === 'Product Range')
                  ? 'grid-cols-3 gap-x-24 gap-y-6 2xl:gap-x-6 2xl:gap-y-30'
                  
                  : link?.mega_menu.length === 2
                  ? 'grid-cols-2 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30'
                  : (link?.mega_menu.length === 1)
                  ? 'grid-cols-1 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30'
                  : link?.mega_menu.length === 4
                  ? 'grid-cols-2 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30'                 
                  : 'grid-cols-3 gap-x-24 gap-y-16 2xl:gap-x-36 2xl:gap-y-30'
              } place-items-stretch`}
            >

              {link?.mega_menu &&
                link?.mega_menu?.map((field: any) => (
                  <>
                    {field?.mega_menu_url?.href === '' ? (
                      <Markdown
                        markdown={field?.mega_menu_content}
                        className={`$ flex ${link?.title === '' ? 'flex-col' : 'flex-col-reverse'} ${
                          link?.title === 'Planning tools'
                            ? '!h-full !w-full font-normal text-[#333] md:text-14 2xl:text-16 [&>img]:mb-12 [&>img]:h-120 [&>img]:!object-fill'
                            : 'font-normal text-black md:text-12 2xl:text-14'
                        }  [&>div>img]:mb-8 [&>div>img]:w-full [&>div>img]:object-cover [&>figure>div>a>img]:mb-8 [&>figure>div>a>img]:object-cover [&>img]:mb-8 [&>img]:object-cover`}
                      />
                    ) : (
                      <Link
                        key={field?.categoryId}
                        link={field?.mega_menu_url?.href}
                        target={field?.mega_menu_url?.href?.includes('https://') ? '_blank' : ''}
                      >      

                        <Markdown
                          markdown={field?.mega_menu_content}
                          className={`$ flex ${link?.title === '' ? 'flex-col' : 'flex-col-reverse'} ${
                            // First condition: Planning tools
                            link?.title === 'Planning tools'
                              ? '!h-full !w-full font-normal text-[#333] md:text-14 [&>img]:h-[10.5rem] [&>img]:w-[8.25rem] xl:[&>img]:h-[13.25rem] xl:[&>img]:w-[12rem] 3xl:[&>img]:h-[17.5rem]  3xl:[&>img]:w-[16rem]'
                              : link?.title === 'About Us'
                              ? 'font-normal text-black md:text-12 2xl:text-14 [&>img]:h-[4.25rem] [&>img]:w-[7.5rem] xl:[&>img]:h-[6.25rem] xl:[&>img]:w-[9.5rem] 3xl:[&>img]:h-[8.25rem]  3xl:[&>img]:w-[12.5rem]'
                              :  link?.title === 'Support'
                              ? 'font-normal text-black md:text-12 2xl:text-14 [&>img]:h-[4.25rem] [&>img]:w-[7.5rem] xl:[&>img]:h-[6.25rem] xl:[&>img]:w-[9.5rem] 3xl:[&>img]:h-[8.25rem]  3xl:[&>img]:w-[12.5rem]'
                              :  link?.title === 'Our Other Brands'
                              ? 'font-normal text-black md:text-12 2xl:text-14 [&>img]:h-[4.25rem] [&>img]:w-[7.5rem] xl:[&>img]:h-[6.25rem] xl:[&>img]:w-[9.5rem] 3xl:[&>img]:h-[8.25rem]  3xl:[&>img]:w-[12.5rem]'

                              : link?.mega_menu.length === 3 && link?.title === 'Product Range'
                              ? 'font-normal text-black md:text-12 2xl:text-14 [&>img]:h-[4.25rem] [&>img]:w-[7.5rem] xl:[&>img]:h-[6.25rem] xl:[&>img]:w-[9.5rem] 3xl:[&>img]:h-[8.25rem]  3xl:[&>img]:w-[12.5rem]'

                              : link?.mega_menu.length === 2 && link?.title === 'Product Range'
                              // Second condition: Kitchen & Laundry with mega_menu.length === 2
                              ? 'font-normal text-black md:text-12 2xl:text-14 [&>img]:h-[10.5rem] [&>img]:w-[8.25rem] xl:[&>img]:h-[13.25rem] xl:[&>img]:w-[12rem] 3xl:[&>img]:h-[17.5rem]  3xl:[&>img]:w-[16rem]'
                              
                              // Third condition: Rest of the conditions (mega_menu length 6, 4, or 2)
                              : (link?.mega_menu.length === 6 || link?.mega_menu.length === 4 || link?.mega_menu.length === 2 || link?.mega_menu.length === 1)
                              ? 'font-normal text-black md:text-12 2xl:text-14 [&>img]:h-[4.25rem] [&>img]:w-[7.5rem] xl:[&>img]:h-[6.25rem] xl:[&>img]:w-[9.5rem] 3xl:[&>img]:h-[8.25rem]  3xl:[&>img]:w-[12.5rem]'
                              : 'font-normal text-black md:text-12 2xl:text-14'
                          }                       
                          font-normal text-black md:text-12 2xl:text-14 [&>div>img]:mb-8 [&>div>img]:w-full [&>div>img]:object-cover [&>figure>div>a>img]:mb-8 [&>figure>div>a>img]:object-cover [&>img]:mb-8 [&>img]:object-cover `}
                        />

                              
                      </Link>
                    )}
                  </>
                ))}

            </div>
            {/* ======================================================================================================================================== */}


            {/* ======================================================================================================================================== */}
            {link?.ctas &&
              link?.ctas.map((cta: any) => (
                <Link
                  link={cta?.button?.href}
                  key={cta?.button?.title}
                  target={cta?.button?.href?.includes('https://') ? '_blank' : ''}
                >
                  <Button
                    icon={<PlusIcon className="w-16 text-[#333]" />}
                    style={{
                      backgroundColor: cta?.button_background_color?.hex,
                      border: `1px solid ${cta?.button_border_color?.hex}`,
                      color: cta?.button_text_color?.hex,
                    }}
                    className={`mt-26 rounded-none px-12 py-12 shadow-sm hover:!bg-[#F4F4F4]`}
                  >
                    <Typography as="span" className="text-14 font-medium text-primary-black">
                      {cta?.button?.title}
                    </Typography>
                  </Button>
                </Link>
              ))}
            {/* ======================================================================================================================================== */}

          </div>
        ))}

      </div>
      {tileContent && <HeaderDropdownTile tileContent={tileContent} />}
    </div>
  );
};

export default MenuDropdown;
